export const StartIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="16" fill="#C3FFC7" />
    <path
      d="M10 26V14H12V26H10ZM24 26L22.575 24.6L26.175 21H14V19H26.175L22.6 15.4L24 14L30 20L24 26Z"
      fill="#01920A"
    />
  </svg>
);

export const StopIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="16" fill="#FFB7B7" />
    <path d="M14 26V14H26V26H14ZM16 24H24V16H16V24Z" fill="#B85656" />
  </svg>
);

export const ItemIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="16" fill="#AFE2FF" />
    <path
      d="M17 27V25H19C18.75 22.7 17.7667 20.7917 16.05 19.275C14.3333 17.7583 12.3167 17 10 17V15C12.15 15 14.125 15.5667 15.925 16.7C17.725 17.8333 19.0833 19.3667 20 21.3C20.6333 19.95 21.4667 18.7542 22.5 17.7125C23.5333 16.6708 24.6917 15.7667 25.975 15H22V13H29V20H27V16.7C25.45 17.65 24.1167 18.825 23 20.225C21.8833 21.625 21.2167 23.2167 21 25H23V27H17Z"
      fill="#3D618D"
    />
  </svg>
);

export const WarningIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="16" fill="#FFB7B7" />
    <path
      d="M10.725 29C10.5416 29 10.375 28.9542 10.225 28.8625C10.075 28.7708 9.95831 28.65 9.87497 28.5C9.79164 28.35 9.74581 28.1875 9.73747 28.0125C9.72914 27.8375 9.77497 27.6667 9.87497 27.5L19.125 11.5C19.225 11.3333 19.3541 11.2083 19.5125 11.125C19.6708 11.0417 19.8333 11 20 11C20.1666 11 20.3291 11.0417 20.4875 11.125C20.6458 11.2083 20.775 11.3333 20.875 11.5L30.125 27.5C30.225 27.6667 30.2708 27.8375 30.2625 28.0125C30.2541 28.1875 30.2083 28.35 30.125 28.5C30.0416 28.65 29.925 28.7708 29.775 28.8625C29.625 28.9542 29.4583 29 29.275 29H10.725ZM12.45 27H27.55L20 14L12.45 27ZM20 26C20.2833 26 20.5208 25.9042 20.7125 25.7125C20.9041 25.5208 21 25.2833 21 25C21 24.7167 20.9041 24.4792 20.7125 24.2875C20.5208 24.0958 20.2833 24 20 24C19.7166 24 19.4791 24.0958 19.2875 24.2875C19.0958 24.4792 19 24.7167 19 25C19 25.2833 19.0958 25.5208 19.2875 25.7125C19.4791 25.9042 19.7166 26 20 26ZM20 23C20.2833 23 20.5208 22.9042 20.7125 22.7125C20.9041 22.5208 21 22.2833 21 22V19C21 18.7167 20.9041 18.4792 20.7125 18.2875C20.5208 18.0958 20.2833 18 20 18C19.7166 18 19.4791 18.0958 19.2875 18.2875C19.0958 18.4792 19 18.7167 19 19V22C19 22.2833 19.0958 22.5208 19.2875 22.7125C19.4791 22.9042 19.7166 23 20 23Z"
      fill="#B85656"
    />
  </svg>
);

export const FrequencyIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 8.65C18.3 9.1 17.7833 9.44167 17.2 9.675C16.6167 9.90833 16.0333 10.025 15.45 10.025C14.8667 10.025 14.2917 9.9125 13.725 9.6875C13.1583 9.4625 12.65 9.11667 12.2 8.65L10.325 6.775C10.075 6.525 9.79167 6.3375 9.475 6.2125C9.15833 6.0875 8.83333 6.025 8.5 6.025C8.16667 6.025 7.84167 6.0875 7.525 6.2125C7.20833 6.3375 6.925 6.525 6.675 6.775L4.8 8.65L3.375 7.225L5.25 5.35C5.7 4.9 6.20833 4.5625 6.775 4.3375C7.34167 4.1125 7.91667 4 8.5 4C9.08333 4 9.65417 4.1125 10.2125 4.3375C10.7708 4.5625 11.275 4.9 11.725 5.35L13.6 7.225C13.8667 7.49167 14.1583 7.6875 14.475 7.8125C14.7917 7.9375 15.1167 8 15.45 8C15.7833 8 16.1125 7.9375 16.4375 7.8125C16.7625 7.6875 17.0583 7.49167 17.325 7.225L19.2 5.35L20.625 6.775L18.75 8.65ZM18.75 13.65C18.3 14.1 17.7875 14.4375 17.2125 14.6625C16.6375 14.8875 16.0583 15 15.475 15C14.8917 15 14.3125 14.8875 13.7375 14.6625C13.1625 14.4375 12.65 14.1 12.2 13.65L10.325 11.775C10.075 11.525 9.79167 11.3375 9.475 11.2125C9.15833 11.0875 8.83333 11.025 8.5 11.025C8.16667 11.025 7.84167 11.0875 7.525 11.2125C7.20833 11.3375 6.925 11.525 6.675 11.775L4.8 13.65L3.375 12.25L5.25 10.35C5.7 9.9 6.20833 9.5625 6.775 9.3375C7.34167 9.1125 7.91667 9 8.5 9C9.08333 9 9.65417 9.1125 10.2125 9.3375C10.7708 9.5625 11.275 9.9 11.725 10.35L13.6 12.225C13.8667 12.4917 14.1583 12.6875 14.475 12.8125C14.7917 12.9375 15.1167 13 15.45 13C15.7833 13 16.1125 12.9375 16.4375 12.8125C16.7625 12.6875 17.0583 12.4917 17.325 12.225L19.2 10.35L20.625 11.775L18.75 13.65ZM18.725 18.65C18.275 19.1 17.7667 19.4375 17.2 19.6625C16.6333 19.8875 16.0583 20 15.475 20C14.8917 20 14.3125 19.8875 13.7375 19.6625C13.1625 19.4375 12.65 19.1 12.2 18.65L10.3 16.775C10.05 16.525 9.76667 16.3375 9.45 16.2125C9.13333 16.0875 8.80833 16.025 8.475 16.025C8.14167 16.025 7.81667 16.0875 7.5 16.2125C7.18333 16.3375 6.9 16.525 6.65 16.775L4.775 18.65L3.375 17.25L5.25 15.35C5.7 14.9 6.20833 14.5625 6.775 14.3375C7.34167 14.1125 7.91667 14 8.5 14C9.08333 14 9.65417 14.1125 10.2125 14.3375C10.7708 14.5625 11.275 14.9 11.725 15.35L13.6 17.225C13.8667 17.4917 14.1625 17.6875 14.4875 17.8125C14.8125 17.9375 15.1417 18 15.475 18C15.8083 18 16.1333 17.9375 16.45 17.8125C16.7667 17.6875 17.0583 17.4917 17.325 17.225L19.2 15.35L20.6 16.775L18.725 18.65Z"
      fill="#787878"
    />
  </svg>
);

export const SignalIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V8C2 7.58333 2.1125 7.20833 2.3375 6.875C2.5625 6.54167 2.86667 6.3 3.25 6.15L15.9 1L16.55 2.65L8.3 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H4ZM4 20H20V13H4V20ZM8 19C8.7 19 9.29167 18.7583 9.775 18.275C10.2583 17.7917 10.5 17.2 10.5 16.5C10.5 15.8 10.2583 15.2083 9.775 14.725C9.29167 14.2417 8.7 14 8 14C7.3 14 6.70833 14.2417 6.225 14.725C5.74167 15.2083 5.5 15.8 5.5 16.5C5.5 17.2 5.74167 17.7917 6.225 18.275C6.70833 18.7583 7.3 19 8 19ZM4 11H16V9H18V11H20V8H4V11Z"
      fill="#787878"
    />
  </svg>
);

export const LevelIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 5.825L6.4 10.4L5 9L12 2L19 9L17.6 10.425L13 5.825V13H11V5.825ZM11 18V15H13V18H11ZM11 22V20H13V22H11Z"
      fill="#787878"
    />
  </svg>
);

export const ModulationIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 21V15H13V17H21V19H13V21H11ZM3 19V17H9V19H3ZM7 15V13H3V11H7V9H9V15H7ZM11 13V11H21V13H11ZM15 9V3H17V5H21V7H17V9H15ZM3 7V5H13V7H3Z"
      fill="#787878"
    />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.475 12L7.12499 4.65C6.87499 4.4 6.75415 4.10417 6.76249 3.7625C6.77082 3.42083 6.89999 3.125 7.14999 2.875C7.39999 2.625 7.69582 2.5 8.03749 2.5C8.37915 2.5 8.67499 2.625 8.92499 2.875L16.6 10.575C16.8 10.775 16.95 11 17.05 11.25C17.15 11.5 17.2 11.75 17.2 12C17.2 12.25 17.15 12.5 17.05 12.75C16.95 13 16.8 13.225 16.6 13.425L8.89999 21.125C8.64999 21.375 8.35832 21.4958 8.02499 21.4875C7.69165 21.4792 7.39999 21.35 7.14999 21.1C6.89999 20.85 6.77499 20.5542 6.77499 20.2125C6.77499 19.8708 6.89999 19.575 7.14999 19.325L14.475 12Z"
      fill="#787878"
    />
  </svg>
);

export const ArrowLeftIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.54995 12L16.9 19.35C17.15 19.6 17.2708 19.8917 17.2625 20.225C17.2541 20.5583 17.125 20.85 16.875 21.1C16.625 21.35 16.3333 21.475 16 21.475C15.6666 21.475 15.375 21.35 15.125 21.1L7.42495 13.425C7.22495 13.225 7.07495 13 6.97495 12.75C6.87495 12.5 6.82495 12.25 6.82495 12C6.82495 11.75 6.87495 11.5 6.97495 11.25C7.07495 11 7.22495 10.775 7.42495 10.575L15.125 2.875C15.375 2.625 15.6708 2.50417 16.0125 2.5125C16.3541 2.52083 16.65 2.65 16.9 2.9C17.15 3.15 17.275 3.44167 17.275 3.775C17.275 4.10833 17.15 4.4 16.9 4.65L9.54995 12Z"
      fill="#787878"
    />
  </svg>
);

export const ExecutionModeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 12.75C10.3375 12.75 9.54063 12.4656 8.85938 11.8969C8.17813 11.3281 7.75 10.6125 7.575 9.75H3V8.25H7.575C7.6375 7.9625 7.72188 7.69375 7.82812 7.44375C7.93438 7.19375 8.075 6.9625 8.25 6.75H4.5V5.25H11.25C12.2875 5.25 13.1719 5.61563 13.9031 6.34688C14.6344 7.07813 15 7.9625 15 9C15 10.0375 14.6344 10.9219 13.9031 11.6531C13.1719 12.3844 12.2875 12.75 11.25 12.75ZM11.25 11.25C11.875 11.25 12.4062 11.0313 12.8438 10.5938C13.2812 10.1562 13.5 9.625 13.5 9C13.5 8.375 13.2812 7.84375 12.8438 7.40625C12.4062 6.96875 11.875 6.75 11.25 6.75C10.625 6.75 10.0938 6.96875 9.65625 7.40625C9.21875 7.84375 9 8.375 9 9C9 9.625 9.21875 10.1562 9.65625 10.5938C10.0938 11.0313 10.625 11.25 11.25 11.25ZM5.25 12.75V11.25H7.5V12.75H5.25Z"
      fill="#787878"
    />
  </svg>
);

export const DelayIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 2.25V0.75H11.25V2.25H6.75ZM8.25 10.5H9.75V6H8.25V10.5ZM9 16.5C8.075 16.5 7.20312 16.3219 6.38438 15.9656C5.56563 15.6094 4.85 15.125 4.2375 14.5125C3.625 13.9 3.14063 13.1844 2.78438 12.3656C2.42813 11.5469 2.25 10.675 2.25 9.75C2.25 8.825 2.42813 7.95313 2.78438 7.13438C3.14063 6.31563 3.625 5.6 4.2375 4.9875C4.85 4.375 5.56563 3.89063 6.38438 3.53438C7.20312 3.17813 8.075 3 9 3C9.775 3 10.5188 3.125 11.2313 3.375C11.9438 3.625 12.6125 3.9875 13.2375 4.4625L14.2875 3.4125L15.3375 4.4625L14.2875 5.5125C14.7625 6.1375 15.125 6.80625 15.375 7.51875C15.625 8.23125 15.75 8.975 15.75 9.75C15.75 10.675 15.5719 11.5469 15.2156 12.3656C14.8594 13.1844 14.375 13.9 13.7625 14.5125C13.15 15.125 12.4344 15.6094 11.6156 15.9656C10.7969 16.3219 9.925 16.5 9 16.5ZM9 15C10.45 15 11.6875 14.4875 12.7125 13.4625C13.7375 12.4375 14.25 11.2 14.25 9.75C14.25 8.3 13.7375 7.0625 12.7125 6.0375C11.6875 5.0125 10.45 4.5 9 4.5C7.55 4.5 6.3125 5.0125 5.2875 6.0375C4.2625 7.0625 3.75 8.3 3.75 9.75C3.75 11.2 4.2625 12.4375 5.2875 13.4625C6.3125 14.4875 7.55 15 9 15Z"
      fill="#787878"
    />
  </svg>
);

export const UploadIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 8.8875L6.84375 10.2938C6.69375 10.4438 6.51563 10.5156 6.30938 10.5094C6.10313 10.5031 5.925 10.425 5.775 10.275C5.6375 10.125 5.56563 9.95 5.55938 9.75C5.55313 9.55 5.625 9.375 5.775 9.225L8.475 6.525C8.55 6.45 8.63125 6.39688 8.71875 6.36563C8.80625 6.33438 8.9 6.31875 9 6.31875C9.1 6.31875 9.19375 6.33438 9.28125 6.36563C9.36875 6.39688 9.45 6.45 9.525 6.525L12.225 9.225C12.375 9.375 12.4469 9.55 12.4406 9.75C12.4344 9.95 12.3625 10.125 12.225 10.275C12.075 10.425 11.8969 10.5031 11.6906 10.5094C11.4844 10.5156 11.3063 10.4438 11.1563 10.2938L9.75 8.8875V14.25C9.75 14.4625 9.67813 14.6406 9.53438 14.7844C9.39063 14.9281 9.2125 15 9 15C8.7875 15 8.60938 14.9281 8.46563 14.7844C8.32188 14.6406 8.25 14.4625 8.25 14.25V8.8875ZM3 6V4.5C3 4.0875 3.14687 3.73438 3.44063 3.44063C3.73438 3.14687 4.0875 3 4.5 3H13.5C13.9125 3 14.2656 3.14687 14.5594 3.44063C14.8531 3.73438 15 4.0875 15 4.5V6C15 6.2125 14.9281 6.39063 14.7844 6.53438C14.6406 6.67813 14.4625 6.75 14.25 6.75C14.0375 6.75 13.8594 6.67813 13.7156 6.53438C13.5719 6.39063 13.5 6.2125 13.5 6V4.5H4.5V6C4.5 6.2125 4.42813 6.39063 4.28438 6.53438C4.14063 6.67813 3.9625 6.75 3.75 6.75C3.5375 6.75 3.35938 6.67813 3.21563 6.53438C3.07188 6.39063 3 6.2125 3 6Z"
      fill="#787878"
    />
  </svg>
);

export const LoadIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 11.6813C8.9 11.6813 8.80625 11.6656 8.71875 11.6344C8.63125 11.6031 8.55 11.55 8.475 11.475L5.775 8.775C5.625 8.625 5.55313 8.45 5.55938 8.25C5.56563 8.05 5.6375 7.875 5.775 7.725C5.925 7.575 6.10313 7.49688 6.30938 7.49063C6.51563 7.48438 6.69375 7.55625 6.84375 7.70625L8.25 9.1125V3.75C8.25 3.5375 8.32188 3.35938 8.46563 3.21563C8.60938 3.07188 8.7875 3 9 3C9.2125 3 9.39063 3.07188 9.53438 3.21563C9.67813 3.35938 9.75 3.5375 9.75 3.75V9.1125L11.1563 7.70625C11.3063 7.55625 11.4844 7.48438 11.6906 7.49063C11.8969 7.49688 12.075 7.575 12.225 7.725C12.3625 7.875 12.4344 8.05 12.4406 8.25C12.4469 8.45 12.375 8.625 12.225 8.775L9.525 11.475C9.45 11.55 9.36875 11.6031 9.28125 11.6344C9.19375 11.6656 9.1 11.6813 9 11.6813ZM4.5 15C4.0875 15 3.73438 14.8531 3.44063 14.5594C3.14687 14.2656 3 13.9125 3 13.5V12C3 11.7875 3.07188 11.6094 3.21563 11.4656C3.35938 11.3219 3.5375 11.25 3.75 11.25C3.9625 11.25 4.14063 11.3219 4.28438 11.4656C4.42813 11.6094 4.5 11.7875 4.5 12V13.5H13.5V12C13.5 11.7875 13.5719 11.6094 13.7156 11.4656C13.8594 11.3219 14.0375 11.25 14.25 11.25C14.4625 11.25 14.6406 11.3219 14.7844 11.4656C14.9281 11.6094 15 11.7875 15 12V13.5C15 13.9125 14.8531 14.2656 14.5594 14.5594C14.2656 14.8531 13.9125 15 13.5 15H4.5Z"
      fill="#787878"
    />
  </svg>
);

export const FitScreenIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 6V4.5H13.5C13.2875 4.5 13.1094 4.42813 12.9656 4.28438C12.8219 4.14063 12.75 3.9625 12.75 3.75C12.75 3.5375 12.8219 3.35938 12.9656 3.21563C13.1094 3.07188 13.2875 3 13.5 3H15C15.4125 3 15.7656 3.14687 16.0594 3.44063C16.3531 3.73438 16.5 4.0875 16.5 4.5V6C16.5 6.2125 16.4281 6.39063 16.2844 6.53438C16.1406 6.67813 15.9625 6.75 15.75 6.75C15.5375 6.75 15.3594 6.67813 15.2156 6.53438C15.0719 6.39063 15 6.2125 15 6ZM1.5 6V4.5C1.5 4.0875 1.64687 3.73438 1.94063 3.44063C2.23438 3.14687 2.5875 3 3 3H4.5C4.7125 3 4.89063 3.07188 5.03438 3.21563C5.17813 3.35938 5.25 3.5375 5.25 3.75C5.25 3.9625 5.17813 4.14063 5.03438 4.28438C4.89063 4.42813 4.7125 4.5 4.5 4.5H3V6C3 6.2125 2.92813 6.39063 2.78438 6.53438C2.64063 6.67813 2.4625 6.75 2.25 6.75C2.0375 6.75 1.85938 6.67813 1.71563 6.53438C1.57188 6.39063 1.5 6.2125 1.5 6ZM15 15H13.5C13.2875 15 13.1094 14.9281 12.9656 14.7844C12.8219 14.6406 12.75 14.4625 12.75 14.25C12.75 14.0375 12.8219 13.8594 12.9656 13.7156C13.1094 13.5719 13.2875 13.5 13.5 13.5H15V12C15 11.7875 15.0719 11.6094 15.2156 11.4656C15.3594 11.3219 15.5375 11.25 15.75 11.25C15.9625 11.25 16.1406 11.3219 16.2844 11.4656C16.4281 11.6094 16.5 11.7875 16.5 12V13.5C16.5 13.9125 16.3531 14.2656 16.0594 14.5594C15.7656 14.8531 15.4125 15 15 15ZM3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64687 14.2656 1.5 13.9125 1.5 13.5V12C1.5 11.7875 1.57188 11.6094 1.71563 11.4656C1.85938 11.3219 2.0375 11.25 2.25 11.25C2.4625 11.25 2.64063 11.3219 2.78438 11.4656C2.92813 11.6094 3 11.7875 3 12V13.5H4.5C4.7125 13.5 4.89063 13.5719 5.03438 13.7156C5.17813 13.8594 5.25 14.0375 5.25 14.25C5.25 14.4625 5.17813 14.6406 5.03438 14.7844C4.89063 14.9281 4.7125 15 4.5 15H3ZM4.5 10.5V7.5C4.5 7.0875 4.64688 6.73438 4.94063 6.44063C5.23438 6.14688 5.5875 6 6 6H12C12.4125 6 12.7656 6.14688 13.0594 6.44063C13.3531 6.73438 13.5 7.0875 13.5 7.5V10.5C13.5 10.9125 13.3531 11.2656 13.0594 11.5594C12.7656 11.8531 12.4125 12 12 12H6C5.5875 12 5.23438 11.8531 4.94063 11.5594C4.64688 11.2656 4.5 10.9125 4.5 10.5ZM6 10.5H12V7.5H6V10.5Z"
      fill="#787878"
    />
  </svg>
);

export const NodeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.54998 12.9375C5.02498 13.375 4.4781 13.575 3.90935 13.5375C3.3406 13.5 2.84373 13.3063 2.41873 12.9563C1.99373 12.6063 1.7031 12.1469 1.54685 11.5781C1.3906 11.0094 1.49373 10.425 1.85623 9.825L3.26248 7.5C2.94998 7.225 2.7031 6.89375 2.52185 6.50625C2.3406 6.11875 2.24998 5.7 2.24998 5.25C2.24998 4.425 2.54373 3.71875 3.13123 3.13125C3.71873 2.54375 4.42498 2.25 5.24998 2.25C6.07498 2.25 6.78123 2.54375 7.36873 3.13125C7.95623 3.71875 8.24998 4.425 8.24998 5.25C8.24998 6.075 7.95623 6.78125 7.36873 7.36875C6.78123 7.95625 6.07498 8.25 5.24998 8.25C5.13748 8.25 5.02498 8.24375 4.91248 8.23125C4.79998 8.21875 4.69373 8.2 4.59373 8.175L3.14998 10.6125C3.01248 10.8375 2.96873 11.0594 3.01873 11.2781C3.06873 11.4969 3.17498 11.675 3.33748 11.8125C3.49998 11.95 3.69373 12.0281 3.91873 12.0469C4.14373 12.0656 4.36248 11.9875 4.57498 11.8125L12.45 5.04375C12.975 4.60625 13.525 4.40938 14.1 4.45313C14.675 4.49688 15.175 4.69375 15.6 5.04375C16.025 5.39375 16.3125 5.85313 16.4625 6.42188C16.6125 6.99063 16.5062 7.575 16.1437 8.175L14.7375 10.5C15.05 10.775 15.2969 11.1063 15.4781 11.4938C15.6594 11.8813 15.75 12.3 15.75 12.75C15.75 13.575 15.4562 14.2813 14.8687 14.8688C14.2812 15.4563 13.575 15.75 12.75 15.75C11.925 15.75 11.2187 15.4563 10.6312 14.8688C10.0437 14.2813 9.74998 13.575 9.74998 12.75C9.74998 11.925 10.0437 11.2188 10.6312 10.6313C11.2187 10.0438 11.925 9.75 12.75 9.75C12.8625 9.75 12.9719 9.75625 13.0781 9.76875C13.1844 9.78125 13.2875 9.8 13.3875 9.825L14.85 7.3875C14.9875 7.1625 15.0312 6.94063 14.9812 6.72188C14.9312 6.50313 14.825 6.325 14.6625 6.1875C14.5 6.05 14.3062 5.97188 14.0812 5.95313C13.8562 5.93438 13.6375 6.0125 13.425 6.1875L5.54998 12.9375ZM12.75 14.25C13.1625 14.25 13.5156 14.1031 13.8094 13.8094C14.1031 13.5156 14.25 13.1625 14.25 12.75C14.25 12.3375 14.1031 11.9844 13.8094 11.6906C13.5156 11.3969 13.1625 11.25 12.75 11.25C12.3375 11.25 11.9844 11.3969 11.6906 11.6906C11.3969 11.9844 11.25 12.3375 11.25 12.75C11.25 13.1625 11.3969 13.5156 11.6906 13.8094C11.9844 14.1031 12.3375 14.25 12.75 14.25ZM5.24998 6.75C5.66248 6.75 6.0156 6.60313 6.30935 6.30938C6.6031 6.01563 6.74998 5.6625 6.74998 5.25C6.74998 4.8375 6.6031 4.48438 6.30935 4.19063C6.0156 3.89688 5.66248 3.75 5.24998 3.75C4.83748 3.75 4.48435 3.89688 4.1906 4.19063C3.89685 4.48438 3.74998 4.8375 3.74998 5.25C3.74998 5.6625 3.89685 6.01563 4.1906 6.30938C4.48435 6.60313 4.83748 6.75 5.24998 6.75Z"
      fill="#787878"
    />
  </svg>
);

export const UndoIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99998 14.25C5.78748 14.25 5.60935 14.1781 5.4656 14.0344C5.32185 13.8906 5.24998 13.7125 5.24998 13.5C5.24998 13.2875 5.32185 13.1094 5.4656 12.9656C5.60935 12.8219 5.78748 12.75 5.99998 12.75H10.575C11.3625 12.75 12.0469 12.5 12.6281 12C13.2093 11.5 13.5 10.875 13.5 10.125C13.5 9.375 13.2093 8.75 12.6281 8.25C12.0469 7.75 11.3625 7.5 10.575 7.5H5.84998L7.27498 8.925C7.41248 9.0625 7.48123 9.2375 7.48123 9.45C7.48123 9.6625 7.41248 9.8375 7.27498 9.975C7.13748 10.1125 6.96248 10.1812 6.74998 10.1812C6.53748 10.1812 6.36248 10.1125 6.22498 9.975L3.52498 7.275C3.44998 7.2 3.39685 7.11875 3.3656 7.03125C3.33435 6.94375 3.31873 6.85 3.31873 6.75C3.31873 6.65 3.33435 6.55625 3.3656 6.46875C3.39685 6.38125 3.44998 6.3 3.52498 6.225L6.22498 3.525C6.36248 3.3875 6.53748 3.31875 6.74998 3.31875C6.96248 3.31875 7.13748 3.3875 7.27498 3.525C7.41248 3.6625 7.48123 3.8375 7.48123 4.05C7.48123 4.2625 7.41248 4.4375 7.27498 4.575L5.84998 6H10.575C11.7875 6 12.8281 6.39375 13.6968 7.18125C14.5656 7.96875 15 8.95 15 10.125C15 11.3 14.5656 12.2812 13.6968 13.0687C12.8281 13.8562 11.7875 14.25 10.575 14.25H5.99998Z"
      fill="#787878"
    />
  </svg>
);

export const RedoIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.15 7.5H7.425C6.6375 7.5 5.95312 7.75 5.37187 8.25C4.79062 8.75 4.5 9.375 4.5 10.125C4.5 10.875 4.79062 11.5 5.37187 12C5.95312 12.5 6.6375 12.75 7.425 12.75H12C12.2125 12.75 12.3906 12.8219 12.5344 12.9656C12.6781 13.1094 12.75 13.2875 12.75 13.5C12.75 13.7125 12.6781 13.8906 12.5344 14.0344C12.3906 14.1781 12.2125 14.25 12 14.25H7.425C6.2125 14.25 5.17187 13.8562 4.30312 13.0687C3.43437 12.2812 3 11.3 3 10.125C3 8.95 3.43437 7.96875 4.30312 7.18125C5.17187 6.39375 6.2125 6 7.425 6H12.15L10.725 4.575C10.5875 4.4375 10.5187 4.2625 10.5187 4.05C10.5187 3.8375 10.5875 3.6625 10.725 3.525C10.8625 3.3875 11.0375 3.31875 11.25 3.31875C11.4625 3.31875 11.6375 3.3875 11.775 3.525L14.475 6.225C14.55 6.3 14.6031 6.38125 14.6344 6.46875C14.6656 6.55625 14.6812 6.65 14.6812 6.75C14.6812 6.85 14.6656 6.94375 14.6344 7.03125C14.6031 7.11875 14.55 7.2 14.475 7.275L11.775 9.975C11.6375 10.1125 11.4625 10.1812 11.25 10.1812C11.0375 10.1812 10.8625 10.1125 10.725 9.975C10.5875 9.8375 10.5187 9.6625 10.5187 9.45C10.5187 9.2375 10.5875 9.0625 10.725 8.925L12.15 7.5Z"
      fill="#787878"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 15.75C4.8375 15.75 4.48438 15.6031 4.19063 15.3094C3.89688 15.0156 3.75 14.6625 3.75 14.25V4.5C3.5375 4.5 3.35938 4.42813 3.21563 4.28438C3.07188 4.14063 3 3.9625 3 3.75C3 3.5375 3.07188 3.35938 3.21563 3.21563C3.35938 3.07188 3.5375 3 3.75 3H6.75C6.75 2.7875 6.82188 2.60938 6.96563 2.46563C7.10938 2.32188 7.2875 2.25 7.5 2.25H10.5C10.7125 2.25 10.8906 2.32188 11.0344 2.46563C11.1781 2.60938 11.25 2.7875 11.25 3H14.25C14.4625 3 14.6406 3.07188 14.7844 3.21563C14.9281 3.35938 15 3.5375 15 3.75C15 3.9625 14.9281 4.14063 14.7844 4.28438C14.6406 4.42813 14.4625 4.5 14.25 4.5V14.25C14.25 14.6625 14.1031 15.0156 13.8094 15.3094C13.5156 15.6031 13.1625 15.75 12.75 15.75H5.25ZM12.75 4.5H5.25V14.25H12.75V4.5ZM7.5 12.75C7.7125 12.75 7.89063 12.6781 8.03438 12.5344C8.17813 12.3906 8.25 12.2125 8.25 12V6.75C8.25 6.5375 8.17813 6.35938 8.03438 6.21563C7.89063 6.07188 7.7125 6 7.5 6C7.2875 6 7.10938 6.07188 6.96563 6.21563C6.82188 6.35938 6.75 6.5375 6.75 6.75V12C6.75 12.2125 6.82188 12.3906 6.96563 12.5344C7.10938 12.6781 7.2875 12.75 7.5 12.75ZM10.5 12.75C10.7125 12.75 10.8906 12.6781 11.0344 12.5344C11.1781 12.3906 11.25 12.2125 11.25 12V6.75C11.25 6.5375 11.1781 6.35938 11.0344 6.21563C10.8906 6.07188 10.7125 6 10.5 6C10.2875 6 10.1094 6.07188 9.96563 6.21563C9.82188 6.35938 9.75 6.5375 9.75 6.75V12C9.75 12.2125 9.82188 12.3906 9.96563 12.5344C10.1094 12.6781 10.2875 12.75 10.5 12.75Z"
      fill="#787878"
    />
  </svg>
);
